import React, { useState } from 'react';
import { Menu, Drawer } from 'antd';
import { MdMenu, MdClose } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import s from './SideMenu.module.sass';

const SideMenu = ({ navItems }) => {
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation('pageHeader');

  const onSwitch = () => {
    setVisible(!visible);
  };

  const onClose = () => {
    setVisible(false);
  };

  const handleMenuItemClick = (link) => {
    navigate(link);
    onClose();
  };

  return (
    <>
      <Drawer 
        open={visible} 
        placement="left" 
        title="Meny" 
        onClose={onClose} 
        width={256}
      >
        <Menu
          style={{ width: 256 }}
          mode="inline"
          items={navItems.map((item, index) => ({
            key: index,
            label: t(item.label),
            onClick: () => handleMenuItemClick(item.link)
          }))}
        />
      </Drawer>
      <button
        onClick={onSwitch}
        className={s.menu}
        aria-label="Toggle menu"
      >
        {!visible ? <MdMenu /> : <MdClose />}
      </button>
    </>
  );
};

export default SideMenu;